import typewriter from '@/analytics/generated/segment'
import { AnalyticsBrowser, AnalyticsSnippet } from '@segment/analytics-next'
import { sessionIdPlugin } from './interceptors/sessionId'

export const segmentClient = typewriter

export const segmentEventWithTypewriter = {
  track: (eventName: string, properties: Record<string, unknown>) => {
    return sendAnalyticsEvent(eventName, properties)
  },
} as AnalyticsSnippet

const writeKey = process.env.SEGMENT_WRITE_KEY ?? ''
export const client = AnalyticsBrowser.load({
  writeKey,
  plugins: [sessionIdPlugin],
})

export const sendAnalyticsEvent = (
  eventName: string,
  properties: Record<string, unknown>
) => {
  return client.track(eventName, { ...properties })
}

segmentClient.setTypewriterOptions({
  analytics: segmentEventWithTypewriter,
})
